import { CommonCard } from "../Common/CommonCard/CommonCard";

type CameraCardAddProps = {
    toggleModal: () => void;
}

const CameraCardAdd: React.FC<CameraCardAddProps> = ({
    toggleModal
}) => {
    return (
        <div className="animated zoomIn col-12 col-md-6 col-xxl-4 cursor-pointer" onClick={toggleModal}>
            <CommonCard
                containerClass={`my-3 h-min-300px animated ${window.innerWidth > 576 ? 'hover-grow' : ''} w-100`}
                background="linear-gradient(to bottom, #666666, #999999)"
                headingLarge="Add a new camera"
                headingSmall="&nbsp;"
                items={
                    <>
                        <div className="text-center mb-7 d-flex justify-content-center align-items-center">
                            <i className="bi bi-camera" style={{ fontSize: "12.5em" }}></i>
                        </div>
                    </>
                }
                buttons={
                    <>
                    </>
                }
            />
        </div>
    )
}

export default CameraCardAdd